export default __webpack_public_path__ + "static/media/minisitcom.9e1f8f19.png";